<template>
  <div id="headers" class="background-blue flex">
    <div class="logo text-center">
      <img class="mt10" src="../assets/img/logo1.png" width="60%" />
    </div>
    <ul class="f1 flex">
      <li v-for="(list, index) in nav" :key="index" @click="checkActive(list)">
        <a href="javascript:;" class="color-white" :class="{'active':list.active}">{{list.title}}</a>
      </li>
    </ul>
    <div class="exit right pr24 color-white">
      <div class="account color-white relative">
        <div id="myPanel" @click.stop="$root.isShowHeaderOpera = !$root.isShowHeaderOpera" class=" mt15 mr10 left">{{$root.loginInfo.account}}<i class="el-icon-caret-bottom"></i></div>        
        <img class="autor right mt10" src="../assets/img/avatar.png"/>
        <ul v-if="$root.isShowHeaderOpera" class="absolute opera">
            <li class="borderb" @click="updatePassword">修改密码</li>
            <li @click="cencel">退出登录</li>
          </ul>
      </div>
    </div>
    <!-- 修改密码 -->
    <el-dialog  title="修改密码"  :visible="dialogVisible"  width="380px" >
        <el-form :model="updatePasswordParam" status-icon :rules="passWordRules" ref="ruleForm" label-width="80px" class="demo-ruleForm">
            <el-form-item label="原密码" prop="oldPwd">
                <el-input v-model.trim="updatePasswordParam.oldPwd" class="width275" placeholder="请输入原来密码" type="password"></el-input>
            </el-form-item>
            <el-form-item label="登录密码" prop="newPwd">
                <el-input v-model.trim="updatePasswordParam.newPwd" class="width275" placeholder="请输入登录密码" type="password"></el-input>
            </el-form-item>
            <el-form-item label="确认密码" prop="qnewPwd" class="last-form-item">
                <el-input v-model.trim="updatePasswordParam.qnewPwd" class="width275" placeholder="请输入确认密码" type="password"></el-input>
            </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
            <el-button size="small" @click="dialogVisible = !dialogVisible">取 消</el-button>
            <el-button size="small" type="primary" @click="confirmOkUpdatePass">确 定</el-button>
        </span>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: 'headers',//顶部导航
  data () {
    let validatePass = (rule, value, callback) => {
            let reg = /^[0-9A-Za-z]{6,20}$/;
			if (value === '') {
				callback(new Error('请输入密码'));
			} else {
                if (!reg.test(value)) {
					callback(new Error('只能输入数字和字母,且长度在6到20位之间'));
				} else {
                    if (this.passWordRules.qnewPwd !== '') {
                        this.$refs.ruleForm.validateField('qnewPwd');
                    } 
                    callback();
                }
			}
      	};
		let validatePass2 = (rule, value, callback) => {
            let reg = /^[0-9A-Za-z]{6,20}$/;
            if (value === '') {
                callback(new Error('请再次输入密码'));
            } else if (value !== this.updatePasswordParam.newPwd) {
                callback(new Error('两次输入密码不一致!'));
            } else {
                if (!reg.test(value)) {
					callback(new Error('只能输入数字和字母,且长度在6到20位之间'));
                } else {
                     callback();       
                }                      
            }
		};
    return {
      nav: this.$root.Permission,
      isShow: false,
      dialogVisible: false,
      account: '',
      updatePasswordParam: {
          id: 0,
          newPwd: "",
          oldPwd: "",
          qnewPwd: ""
      },
      passWordRules:{
        oldPwd: [{required:true,message:'请输入原来密码',trigger:'blur'}],
				newPwd: [{required:true,message:'请设置登录密码',trigger:'blur'},
						  {validator: validatePass, trigger: 'blur' }],
				qnewPwd: [{required:true,message:'请输入确认密码',trigger:'blur'},
						{validator: validatePass2, trigger: 'blur' }]			
			},
    }
  },
  watch: {
    dialogVisible (val) {
      if (!val) {
          this.clearPassWord();
      }            
    },
  },
  methods: {
    clearPassWord () {
        this.updatePasswordParam.newPwd = "";
        this.updatePasswordParam.qnewPwd = "";
        this.updatePasswordParam.oldPwd = "";       
        this.$refs.ruleForm.resetFields();
    },
    updatePassword () {
      this.dialogVisible = true;
      this.isShow = false;
    },
    //确认修改密码
    confirmOkUpdatePass () {
        let param = {currentPassword: this.md5(this.updatePasswordParam.oldPwd), newPassword: this.md5(this.updatePasswordParam.newPwd)}
        this.$refs.ruleForm.validate( (status) => {
            if (status) {
                this.$http('POST', '/admin/boss/update/password', {}, param, (status, res) => {
                    if (status) {
                        if (res.status === '200') {
                            this.$message({type: 'success', message: res.message});
                            this.dialogVisible = false;
                        } else {
                            this.$message({type: 'error', message: res.message});
                        }
                    }
                });
            }
        });
    },
    checkActive (item) {
      this.$root.Permission.forEach( el => {//初始化一级菜单为非选中状态
        el.active = false;
      });
      item.active = true;//改变当前点击值为选中状态
      let isActive = false
      item.item.forEach(el => {
          if (el.active) { // 判断当前菜单下是否有打开的菜单
              isActive = true
              return
          }
      })
      if (!isActive) { // 如果没有打开的，则默认打开第一个
          item.item[0].active = true
      }
    },
    cencel () {
      this.$confirm('确定退出登录吗?', '提示', {confirmButtonText: '确定', cancelButtonText: '取消', type: 'warning'
      }).then(() => {
          this.$http('post', '/admin/logout', {}, {}, (statu, data) => {
            sessionStorage.removeItem('token')
            this.goPath('/login')
          });
      }).catch(() => {})
    }
  },
  mounted () {
    console.log('this.$root.Permission....',this.$root.loginInfo)
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
#headers{width:100%; height:50px;}
#headers .logo{width: 180px; background:#2F2F3B; text-align: center;}
#headers .logo > img {line-height: 50px;}
#headers > ul li{height: 50px;line-height: 50px;position: relative;margin-left: 1px;}
#headers > ul li a{height: 50px;padding: 0 15px;display: block;}
/* #headers ul li::before{content: '';width: 1px;height: 14px;background: #1E61D1;position: absolute;left: -1px;top: 22px;display: block;} */
/* #headers ul li:first-child::before{width: 0;} */
#headers ul li .active{background: #186BDF;}
#headers ul li a:hover{background: #186BDF;}
#headers .autor{width: 29px; height: 29px; border-radius: 50%; vertical-align: middle;}
#headers .exit{cursor: pointer;}
#headers .opera{width: 160px; background: #fff; text-align: center; color: #2F2F3B; top: 43px; right: 0;}
#headers .opera li{padding: 10px 0; color: #666666}
#headers .opera .borderb{border-bottom: 1px solid #EFF2FA;}
#headers .opera li:hover{background: #2480ED; color: #fff;}
#headers >>>.width275.el-input{ height: 36px; border-radius: 2px;}
#headers >>>.width275.el-input .el-input__inner{ height: 36px; border-radius: 2px;}
</style>



// WEBPACK FOOTER //
// src/components/header.vue